import { useEffect, useState } from 'react';
import { getGuilds } from '../api';
import { Guild } from '../types';
import { useNavigate } from "react-router-dom";

export function useFetchGuild() {
  const [guilds, setGuilds] = useState<Guild[]>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    getGuilds()
    .then(({ data }) => {
      setGuilds(data);
    })
    .catch((err) => {
      console.log(err);
      navigate('/')
      setError(err);
    })
    .finally(() => setLoading(false))
  }, [navigate]);

  return { guilds, error, loading };
}